<br />
<div class="user-profile-view">
  <div>
    <img
      class="user-img rounded-circle"
      [src]="
        details?.image ? details?.image : '/assets/images/dashboard/man.png'
      "
      alt="app-user-profile-img"
    />
  </div>
  <div class="username-view">
    <label class="user-name"
      >{{ details?.first_name }} {{ details?.last_name }}</label
    ><br />
    <!-- For verification status -->
    <div class="other-details-view">
      <ng-container
        *ngIf="
          allFeatures?.is_enabled === true &&
          cashOutFeature?.is_enabled === true
        "
      >
        <label
          class="status fully-verified"
          *ngIf="
            VERIFICATION === 'FULLY_VERIFIED' ||
            VERIFICATION === 'VERIFIED' ||
            VERIFICATION === 'VERIFIED_2'
          "
        >
          <div class="mr-1">
            <img src="./assets/images/svg/check.svg" />
          </div>
          {{ VERIFICATION }}</label
        >
        <label
          class="status soft-deleted"
          *ngIf="VERIFICATION === 'SOFT_DELETED' || VERIFICATION === 'PENDING'"
          >{{ VERIFICATION }}</label
        >
        <label
          class="status unverified"
          *ngIf="VERIFICATION === 'UNVERIFIED'"
          >{{ VERIFICATION }}</label
        >
        <label
          class="status jumio"
          *ngIf="
            VERIFICATION === 'BOUNCED_JUMIO' || VERIFICATION === 'FAILED_JUMIO'
          "
          >{{ VERIFICATION }}</label
        >
      </ng-container>

      <label
        class="status suspended"
        *ngIf="cashOutFeature?.is_enabled === false"
      >
        <div class="mr-1">
          <img src="./assets/images/svg/warning-circle.svg" />
        </div>
        {{ cashOutFeature?.is_enabled ? "" : "SUSPENDED" }}
      </label>

      <label class="status suspended" *ngIf="allFeatures?.is_enabled === false">
        <div class="mr-1">
          <img src="./assets/images/svg/warning-circle.svg" />
        </div>
        {{ allFeatures?.is_enabled ? "" : "SUSPENDED" }}
      </label>

      <label
        class="status blocked"
        *ngIf="details?.account_non_locked === false"
      >
        {{ details?.account_non_locked ? "" : "Blocked" }}
      </label>

      <label class="contacts">{{ details?.email }} </label>
      <label class="contacts"
        >+{{ details?.country_code }}{{ details?.phone_number }}</label
      >
    </div>
  </div>
</div>

<div class="row mt-4 app-user-profile">
  <div class="col-md-12">
    <div class="card">
      <div class="card-body">
        <!-- Wallet balances -->
        <app-user-wallets [details]="details"></app-user-wallets>

        <!-- User Transactions -->
        <app-generic-partner-user-transactions></app-generic-partner-user-transactions>
      </div>
    </div>
  </div>
</div>
